import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import type { InvokeDefinition } from '../../signalr/types'
import { successfulHeartbeat } from './actions'

export const heartbeatDefinition: InvokeDefinition<[], void, Action> = {
  method: 'SingleHeartbeat',
  strategy: 'switch',
  getParams,
  mapResponse: successfulHeartbeat
}
